var _path, _polygon;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgCopy(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "24px",
    height: "24px",
    viewBox: "-4 0 22 20",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M2.92899408,3.11538462 L2.92899408,18 L17.8136095,18 L17.8136095,3.11538462 L2.92899408,3.11538462 Z M3.83431953,4.02071006 L16.908284,4.02071006 L16.908284,17.0946746 L3.83431953,17.0946746 L3.83431953,4.02071006 Z",
    id: "Shape"
  })), _polygon || (_polygon = /*#__PURE__*/React.createElement("polygon", {
    id: "Path",
    points: "-1.27897692e-14 14.4319527 -1.27897692e-14 -1.11910481e-14 14.4319527 -1.11910481e-14 14.4319527 0.905325444 0.905325444 0.905325444 0.905325444 14.4319527"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCopy);
export default __webpack_public_path__ + "static/media/copy.407e89387530cbc0681bddd903bc8f51.svg";
export { ForwardRef as ReactComponent };